<template>
  <v-card flat>
    <v-row>
      <v-col>
        <v-data-table
          :headers="matrixTableHeaders"
          :items="qMatrixDetails"
          :search="matrixQuery"
          dense
          class="table-background"
        >
          <template v-slot:top>
            <v-toolbar flat color="#eee">
              <v-text-field
                v-model="matrixQuery"
                append-icon="mdi-magnify"
                label="Search for a Q-matrix..."
                placeholder="EP 2021"
                single-line
                hide-details
                clearable
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary">Create Q-Matrix*</v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item="props">
            <tr :active="props" @click="selectQMatrix(props.item)">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.is_authoritative }}</td>
              <td>{{ props.item.q_matrix_task_item_mappings.length }}</td>
              <td>{{ formatDate(props.item.created_at) }}</td>
              <td>{{ formatDate(props.item.updated_at) }}</td>
              <td>
                <v-icon
                  small
                  class="ml-3"
                  @click="$goMatrixProfile(props.item.id)"
                >
                  mdi-pencil
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card v-if="isMatrixSelected" flat color="#eee">
          <v-data-table
            :headers="matrixItemTableHeaders"
            :items="selectedQMatrix.qMatrixTaskItemMappings"
            :search="itemQuery"
            dense
            class="table-background"
          >
            <template v-slot:top>
              <v-toolbar flat color="#eee">
                <v-text-field
                  v-model="itemQuery"
                  append-icon="mdi-magnify"
                  label="Search for an item..."
                  placeholder="hypothesis_score, PNS-gdex"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item="props">
              <tr>
                <td>{{ props.item.task_item.code }}</td>
                <td>{{ props.item.task_item.name }}</td>
                <td>{{ formatDate(props.item.task_item.created_at) }}</td>
                <td>{{ formatDate(props.item.task_item.updated_at) }}</td>
                <td>
                  <v-icon
                    small
                    class="ml-3"
                    @click="$goItemProfile(props.item.task_item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: ['qMatrixDetails'],
  data () {
    return {
      matrixQuery: '',
      itemQuery: '',
      selectedQMatrix: {},
      isMatrixSelected: false,
      matrixTableHeaders: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Authoritative', value: 'is_authoritative', sortable: true },
        {
          text: 'Number of Items',
          value: 'q_matrix_task_item_mappings',
          sortable: true
        },
        { text: 'Date Created', value: 'created_at', sortable: true },
        { text: 'Last Updated', value: 'updated_at', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      matrixItemTableHeaders: [
        { text: 'Code', value: 'code', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Date Created', value: 'created_at', sortable: true },
        { text: 'Last Updated', value: 'updated_at', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  async created () {
    await this.getTaskDetails()
  },
  methods: {
    async getTaskDetails () {
      this.taskDetails = await this.tasks.find(
        (task) => parseInt(task.id) === parseInt(this.id)
      )
    },
    selectQMatrix (rowData) {
      this.selectedQMatrix.id = rowData.id
      this.selectedQMatrix.name = rowData.name
      this.selectedQMatrix.taskId = rowData.task_id
      this.selectedQMatrix.isAuthoritative = rowData.is_authoritative
      this.selectedQMatrix.qMatrixTaskItemMappings =
        rowData.q_matrix_task_item_mappings
      this.selectedQMatrix.createdAt = rowData.created_at
      this.selectedQMatrix.updatedAt = rowData.updated_at
      this.isMatrixSelected = true
    },
    parseTaskName (taskId) {
      const matchedTask = this.tasks.find(
        (task) => task.id === parseInt(taskId)
      )
      if (matchedTask) {
        return matchedTask.name
      }
    },
    getTaskMap (tasks) {
      return [
        ...new Set(
          tasks.map((task) => ({ name: task.name, task_id: task.id }))
        )
      ]
    },
    formatDate (dateString) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' }
      const parsedDate = new Date(dateString)
      return parsedDate.toLocaleString('en-US', options)
    }
  }
}
</script>

<style scoped>
.table-background {
  background-color: #eee;
}
</style>
